import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import {
    isCurrentEnterprisePortfolio,
    isCurrentEnterpriseApplicationProvider,
    isCurrentEnterpriseServiceProviderWithBookableService,
} from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { isSalesForceInitialized } from '@mews-commander/chat';
import { isDemo as isDemoSelector } from '../../../app/reducers/configuration';
import { Dashboard, DashboardProps } from './Dashboard';

export default connect(
    createStructuredSelector<ApplicationState, DashboardProps>({
        currentEnterpriseId: getCurrentEnterpriseId,
        isDemo: isDemoSelector,
        // @ts-expect-error $TSFixMeError: session selectors are not typed
        isServiceProvider: isCurrentEnterpriseServiceProviderWithBookableService,
        // @ts-expect-error $TSFixMeError: session selectors are not typed
        isApplicationProvider: isCurrentEnterpriseApplicationProvider,
        isPortfolio: isCurrentEnterprisePortfolio,
        isSalesForceChatInitialized: isSalesForceInitialized,
    })
)(Dashboard);
